<template>
    <div>
        <div class="row">
            <div class="column small-5">
                <PageTitle title="Boxen" :total="total" :loading="loading" />
            </div>
            <div class="column small-7 text-right">
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left" v-if="user.role != 'pit'">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <router-link :to="{ name: 'UserSettings' }">
                    <b-button type="is-secondary" icon-right="cog"></b-button>
                </router-link>
                <b-button type="is-dark" @click="changeView('floorplan')" v-if="view == 'list'">Plattegrond weergave</b-button>
                <b-button type="is-dark" @click="changeView('list')" v-else-if="view == 'floorplan'">Lijst weergave</b-button>
            </div>
        </div>

        <div class="row" v-if="view == 'list'">
            <div class="column">
                <b-field label="Zoek een box">
                    <b-autocomplete
                        :data="boxesFound"
                        field="number"
                        placeholder="Zoek op nummer"
                        :loading="isFetching"
                        @typing="findBox"
                        clearable
                        @clear="boxesFound = []"
                        @select="option => selectedBox = option">
                        <template v-slot="props">
                            <span v-if="user && user.role == 'pit' && dataBelongsTo == 'all'">{{ organisations[props.option.organisation].name }}&nbsp;-&nbsp;</span>
                            <strong>Nummer:</strong> {{ props.option.number }}&nbsp;-&nbsp;<strong>Grootte:</strong> {{ props.option.size || '-' }}m<sup>3</sup>&nbsp;-&nbsp;<strong>Prijs:</strong> &euro;&nbsp;{{ props.option.price}}
                        </template>
                    </b-autocomplete>
                </b-field>
            </div>
        </div>

        <div class="row" v-if="filters && Object.keys(filters).length">
            <div class="column">
                <h5>Filters</h5>

                <b-field>
                    <b-tag v-if="filters.hide_online && filters.hide_online == 1"
                        type="is-primary"
                        close-type='is-danger'
                        attached
                        closable
                        aria-close-label="Filter verwijderen"
                        @close="removeFilter('hide_online')"
                    >
                        Online verborgen boxen
                    </b-tag>
                </b-field>
            </div>
        </div>

        <div class="row">
            <div class="column" v-if="view == 'list'">
                <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                >
                    <template>
                        <b-table-column v-slot="props" field="organisation" label="Org." width="50" :visible="user && user.role == 'pit' && $store.state.dataBelongsTo === 'all'" class="admin">
                            <b-button type="is-primary" outlined tag="router-link" size="is-small" :to="{ name: 'OrganisationsRecord', params: {id: props.row.organisation} }" v-if="user && user.role == 'pit'">
                                {{ organisations[props.row.organisation].short_name }}
                            </b-button>
                        </b-table-column>

                        <b-table-column v-slot="props" field="number" label="Nmr." width="40" sortable>
                            {{ props.row.number }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="status" label="Status" width="200" sortable>
                            <BoxesOverviewStatus
                                :status="props.row.status"
                                :available_at="props.row.available_at"
                            />
                        </b-table-column>

                        <b-table-column v-slot="props" field="size" width="125" label="Inhoud" class="show-for-large" sortable>
                            {{ props.row.size }}m³

                            <b-tooltip :label="`LxBxH: ${props.row.length ? props.row.length : '-'} x ${props.row.width ? props.row.width : '-'} x ${props.row.height ? props.row.height : '-'}`" v-if="props.row.length && props.row.width">
                                <b-icon size="is-small" icon="info-circle" />
                            </b-tooltip>
                        </b-table-column>

                        <b-table-column v-slot="props" field="price" label="Prijs" numeric sortable>
                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                            <span v-else-if="props.row.price > 0">&euro;&nbsp;{{ props.row.price }}</span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="customer_id" label="Klant" sortable>
                            <!-- <span v-if="hideSensitiveData">********</span>
                            <span v-else-if="props.row.customer">
                                {{ props.row.customer.firstname }}&nbsp;{{ props.row.customer.lastname }}
                                <span v-if="!_.isNull(props.row.customer.companyname) && props.row.customer.type == 'business'" :icon="!_.isNull(props.row.customer.companyname) && props.row.customer.type == 'business' ? 'building' : 'people'">
                                    <br><strong>{{ props.row.customer.companyname }}</strong>
                                </span>
                            </span> -->
                            <b-button tag="router-link" type="is-text" size="is-small" class="text-left" :to="{ name: 'CustomersRecord', params: {id: props.row.customer.id} }" v-if="props.row.customer">
                                <span v-if="hideSensitiveData">********</span>
                                <span v-else>
                                    {{ props.row.customer.firstname }}&nbsp;{{ props.row.customer.lastname }}
                                    <span v-if="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation')" :icon="!_.isNull(props.row.customer.companyname) && (props.row.customer.type == 'business' || props.row.customer.type == 'foundation') ? 'building' : 'people'">
                                        <br><strong>
                                            <span v-if="props.row.customer.companyname.length >= 27">
                                                <b-tooltip :label="props.row.customer.companyname" position="is-top">
                                                    {{ props.row.customer.companyname|truncate(25, '..') }}
                                                </b-tooltip>
                                            </span>
                                            <span v-else>{{ props.row.customer.companyname }}</span>
                                        </strong>
                                    </span>
                                </span>
                            </b-button>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="contract" label="Ctrt." sortable>
                            <span v-if="props.row.customer_id && _.isNull(props.row.contract)">
                                <b-tooltip label="Gebruiker gekoppeld aan box maar nog geen contract actief." type="is-dark">
                                    <b-button tag="router-link" :to="'/panel/contracten/nieuw?box='+props.row.id+'&customer='+props.row.customer_id" type="is-warning" size="is-small">
                                        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                                    </b-button>
                                </b-tooltip>
                            </span>
                            <span v-else-if="props.row.customer_id && props.row.contract">
                                <b-button tag="router-link" :to="'/panel/contracten/'+props.row.contract" type="is-success" size="is-small">
                                    <font-awesome-icon :icon="['fas', 'check']" />
                                </b-button>
                            </span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="updated_at" label="Gewijzigd" width="180" sortable>
                            <span>{{ props.row.updated_at|humanDate }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" numeric width="100">
                            <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'BoxesRecord', params: {id: props.row.id} }">Bekijken</b-button>
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">Geen boxen gevonden.</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
            <div class="column paddingtop0" v-else-if="view == 'floorplan'">
                <FloorPlan
                    ref="floorplan"
                />
            </div>
        </div>
    </div>
</template>

<script>
import FloorPlan from './FloorPlan.vue'
import BoxesOverviewStatus from './BoxesOverviewStatus.vue'
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'
import statusFiltersMixin from '@/mixins/statusFiltersMixin'

export default {
    name: 'BoxesOverview',
    mixins: [filtersMixin, paramsMixin, statusFiltersMixin],

    components: {
        FloorPlan,
        BoxesOverviewStatus
    },
    data () {
        return {
            // view: 'list',
            records: [],

            total: null,
            loading: false,
            sortField: 'updated_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 35,
            searchParams: typeof(this.$store.state.searchQueries['BoxOverview']) != 'undefined' ? this.$store.state.searchQueries['BoxOverview'] : null,

            boxesFound: [],
            selectedBox: null,
            isFetching: false,
            filters: {}
        }
    },
    computed: {
        view(){
            return this.$store.state.boxView
        },
        paginated(){
            return this.records && (this.records.length < this.total)
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },
    created(){
        if(_.has(this.$route.query, 'list') && this.$route.query.list == 1){
            this.changeView('list')

            if(_.has(this.$route.query, 'hide_online') && this.$route.query.hide_online == 1){
                this.loadAsyncData('hide_online=1')
                this.filters.hide_online = this.$route.query.hide_online
            }

            return
        }

        if(_.has(this.$route.query, 'floormap') && this.$route.query.floormap == 1){
            this.changeView('floorplan')
            return
        }

        // Check if in this session a query is saved (last success) else use default sorting.
        this.getSearchParams().then(() => {
            this.loadAsyncData()
        })

        if(_.has(this.user, 'settings.open_preference') && this.user.settings.open_preference == 1){
            this.$store.dispatch('setBoxView', 'list')
        } else if(_.has(this.user, 'settings.open_preference') && this.user.settings.open_preference != 1){
            this.$store.dispatch('setBoxView', 'floorplan')
        }
    },
    methods: {
        loadAsyncData(passParams = null) {
            // Set filter params & admin params
            let params = this.setParams(this.searchParams, 'BoxOverview')
            if (passParams) {
                params += `&${passParams}`
            }

            if (this.selectedFilters.length > 0 && this.selectedFilters.length !== this.possibleFilters.length) {
                params += `&status=${this.selectedFilters.join(',')}`
            }

            // Check if params are the same as last request, if so return
            if (this.$store.state.searchQueries['BoxOverview'] === params) {
                console.log('[🔥] Same params as last request, skipping...')
                return
            }

            this.loading = true

            axios.get(`/api/boxes?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: 'BoxOverview', query: params})
            }).catch((error) => {
                console.error('[❌] Error while fetching boxes:', error)
                this.data = []
                this.total = null
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })
        },

        debounceAsyncData: _.debounce(function () {
            this.loadAsyncData()
        }, 250),

        findBox: _.debounce(function (name) {
            if (this.$refs.floorplan){
                this.$refs.floorplan.selectBox(null)
            }

            if (!name.length) {
                if (this.$refs.floorplan){
                    this.$refs.floorplan.selectBox(null)
                }
                this.data = []
                // Continue with search but without search param
            }
            this.isFetching = true

            let searchParm = `search=${name}`
            if (this.user?.role === 'pit') {
                searchParm += `&organisation=${this.dataBelongsTo}`
            }

            axios.get(`/api/boxes/find?${searchParm}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.boxesFound = response.data.data

                if (this.view == 'floorplan' && response.data.data.length == 1 && this.$refs.floorplan) {
                    this.$refs.floorplan.selectBox(response.data.data[0])
                }
            }).catch((error) => {
                console.error('[❌] Error while searching box:', error)
            }).then(() => {
                this.isFetching = false
            })
        }, 250),

        changeView(view){
            if(!view) return false;
            // this.view = view
            this.$store.dispatch('setBoxView', view)
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        },

        removeFilter(filter){
            delete this.filters[filter]

            this.setParams(Object.keys(this.filters).length ? this.filters : this.searchParams, 'BoxOverview')
            this.$router.push({ query: this.filters })

            this.loadAsyncData()
        }
    },

    watch: {
        // Go to selected box
        selectedBox(newVal){
            if(!_.isNull(newVal)){
                this.$router.push({'name': 'BoxesRecord', params: {id: newVal.id}})
            }
        },

        view(newVal){
            if (newVal === 'list') {
                this.loadAsyncData()
            }
        },

        // what is this?
        dataBelongsTo(newVal, oldVal){
            if(newVal){
                this.$store.dispatch('setSearchQuery', {type: 'BoxOverview', query: null})
            }
        },

        selectedFilters() {
            if (this.view === 'list') {
                this.loading = true
                this.debounceAsyncData()
            }
        }
    }
}
</script>